<template>
	<div class="update">
		<h2 class="qjc-fts-20 qjc-c-dark qjc-ftw-500">礼品卡销售统计 </h2>

		<div class="wrap">
			<!-- 大陆体检 -->
			<div class="mainland">
				<div class="mainland-header">
					<div class="mainland-title">大陆体检</div>
					<div class="mainland-action ">
						<!-- 大陆体检统计总应收款 -->
						<div class="receivables">
							总应收款：{{
								list.reduce((x, y) => {
									return x + y.receivables;
								}, 0)
							}}
						</div>
						<!-- 大陆体检统计总实收款 -->
						<div class="actual-collection">
							总实收款：
							<span class="red-text">
								{{
									list.reduce((x, y) => {
										return x + y.actual;
									}, 0)
								}}
							</span>
						</div>
						<el-date-picker
							  class="year-picker"
							  :picker-options="pickerOptions" 
						      v-model="tYear"
							  value-format="yyyy"
						      type="year"
						      placeholder="选择年份">
						</el-date-picker>
						<el-select v-model="tMonth" class="month-select" placeholder="请选择月份">
						    <el-option
						      v-for="item in tMonthList"
						      :key="item.value"
						      :label="item.label"
						      :value="item.value">
						    </el-option>
						</el-select>
						<el-button class="mainland-btn" @click="handleAction">确定</el-button>
					</div>
				</div>
				<el-table
					ref="cardTabel"
					:data="list"
					border
					:class-style="{ borderColor: '#F1F5FC', textAlign: 'center' }"
					:header-cell-style="{ height: '54px', borderRight: '2px solid #E9EFF8', textAlign: 'center', color: '#777F8F', backgroundColor: '#F1F5FC' }"
					class="list qjc-fts-14 tabel-header"
					header-cell-class-name="list-header qjc-ftw-500 qjc-c-dark" >
					<el-table-column prop="channel" label="销售渠道">
						<template slot-scope="scope">
							{{ scope.row.channel == '1' ? '礼品卡' : scope.row.channel == '2' ? '网站' : '--' }}
						</template>
					</el-table-column>
					<el-table-column prop="sold" label="已销售">
						<template slot-scope="scope">
							{{ scope.row.sold ? scope.row.sold : '--' }}
						</template>
					</el-table-column>
					<el-table-column prop="used" label="已使用">
						<template slot-scope="scope">
							{{ scope.row.used ? scope.row.used : '--' }}
						</template>
					</el-table-column>
					<el-table-column prop="receivables" label="应收款">
						<template slot-scope="scope">
							{{ scope.row.receivables ? scope.row.receivables : '--' }}
						</template>
					</el-table-column>
					<el-table-column prop="actual" label="实收款">
						<template slot-scope="scope">
							<div :class="scope.row.actual == scope.row.receivables ? '' : 'red-text'">{{ scope.row.actual ? scope.row.actual : '--' }}</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!-- 香港体检统计 -->
			<div class="mainland">
				<div class="mainland-header">
					<div class="mainland-title">香港体检</div>
					<div class="mainland-action ">
						<!-- 香港体检统计总应收款 -->
						<div class="receivables">
							总应收款：{{
								list2.reduce((x, y) => {
									return x + y.receivables;
								}, 0)
							}}
						</div>
						<!-- 香港体检统计总实收款 -->
						<div class="actual-collection">
							总实收款：
							<span class="red-text">
								{{
									list2.reduce((x, y) => {
										return x + y.actual;
									}, 0)
								}}
							</span>
						</div>
						<el-date-picker
							  class="year-picker"
							  :picker-options="pickerOptions" 
						      v-model="HKYear"
							  value-format="yyyy"
						      type="year"
						      placeholder="选择年份">
						</el-date-picker>
						<el-select v-model="HKMonth" class="month-select" placeholder="请选择月份">
						    <el-option
						      v-for="item in HKMonthList"
						      :key="item.value"
						      :label="item.label"
						      :value="item.value">
						    </el-option>
						</el-select>
						<el-button class="mainland-btn" @click="handleHKAction">确定</el-button>
					</div>
				</div>
				<el-table
					ref="cardTabel"
					:data="list2"
					border
					:class-style="{ borderColor: '#F1F5FC', textAlign: 'center' }"
					:header-cell-style="{ height: '54px', borderRight: '2px solid #E9EFF8', textAlign: 'center', color: '#777F8F', backgroundColor: '#F1F5FC' }"
					class="list qjc-fts-14 tabel-header"
					header-cell-class-name="list-header qjc-ftw-500 qjc-c-dark" >
					<el-table-column prop="channel" label="销售渠道">
						<template slot-scope="scope">
							{{ scope.row.channel == '1' ? '礼品卡' : scope.row.channel == '2' ? '网站' : '--' }}
						</template>
					</el-table-column>
					<el-table-column prop="sold" label="已销售">
						<template slot-scope="scope">
							{{ scope.row.sold ? scope.row.sold : '--' }}
						</template>
					</el-table-column>
					<el-table-column prop="used" label="已使用">
						<template slot-scope="scope">
							{{ scope.row.used ? scope.row.used : '--' }}
						</template>
					</el-table-column>
					<el-table-column prop="receivables" label="应收款">
						<template slot-scope="scope">
							{{ scope.row.receivables ? scope.row.receivables : '--' }}
						</template>
					</el-table-column>
					<el-table-column prop="actual" label="实收款">
						<template slot-scope="scope">
							<div :class="scope.row.actual == scope.row.receivables ? '' : 'red-text'">{{ scope.row.actual ? scope.row.actual : '--' }}</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
	</div>
</template>

<script>
// import {   } from '@/utils/axios.js'

export default {
	name: 'mainGiftCardSales',
	data() {
		return {
			submiting: false, // 正在请求
			list: [
				{
					channel: '1', // 渠道
					sold: 100,  // 已销售
					used: 100,  // 已使用
					receivables: 19800,  // 应收款
					actual: 16800  // 实收款
				},
				{
					channel: '2',
					sold: 50,
					used: 50,
					receivables: 9900,
					actual: 8400
				}
			],
			list2: [
				{
					channel: '1',
					sold: 100,
					used: 100,
					receivables: 19800,
					actual: 16800
				},
				{
					channel: '2',
					sold: 50,
					used: 50,
					receivables: 9900,
					actual: 8400
				}
			],
			tYear: '', //大陆选中年份
			HKYear: '', //香港选中年份
			tMonth: '', //大陆选中月份
			HKMonth: '', //香港选中月份
			pickerOptions: {}, //年份选择范围
			monthList: [
				{
				  value: '全年',
				  label: '全年'
				},{
				  value: '1',
				  label: '1月'
				},{
				  value: '2',
				  label: '2月'
				},{
				  value: '3',
				  label: '3月'
				},{
				  value: '4',
				  label: '4月'
				},{
				  value: '5',
				  label: '5月'
				},{
				  value: '6',
				  label: '6月'
				},{
				  value: '7',
				  label: '7月'
				},{
				  value: '8',
				  label: '8月'
				},{
				  value: '9',
				  label: '9月'
				},{
				  value: '10',
				  label: '10月'
				},{
				  value: '11',
				  label: '11月'
				},{
				  value: '12',
				  label: '12月'
				},
			],
			tMonthList: [], //大陆体检月份列表
			HKMonthList: [],//香港体检月份列表
		};
	},

	mounted() {
		this.tYear = new Date(); // 大陆初始年份
		this.HKYear = new Date(); // 香港初始年份
		let nowMonth = new Date().getMonth() + 1; //当前月份
		this.tMonth = nowMonth + ''; //默认选中当前月份 大陆
		this.HKMonth = nowMonth + ''; //默认选中当前月份 香港
		this.pickerOptions = {
			disabledDate: 
				(time) => {
				   return (
					   time > new Date()
				   )
				}
		}; // 年份选择范围 不能大于当前年份
		
	},
	components: {},
	watch: {
		tYear(newVal, oldVal) {
			let nowYear = new Date().getFullYear();  //当前年份
			let nowMonth = new Date().getMonth() + 1; //当前月份
			let oldYear = typeof oldVal == 'string' ? oldVal : (oldVal instanceof Object ? oldVal.getFullYear() : '') 
			let newYear = typeof newVal == 'string' ? newVal : (newVal instanceof Object ? newVal.getFullYear() : '') // 是否为初始时间 或 清空
			let list = this.monthList
			// 选中当前年份时，月份列表截止当前月份
			if(nowYear == newYear){
				this.tMonthList = list.slice(0, nowMonth + 1)
				return
			}else {
				this.tMonthList = list
			}
		},
		HKYear(newVal, oldVal) {
			let nowYear = new Date().getFullYear(); // 当前年份
			let nowMonth = new Date().getMonth() + 1; // 当前月份
			let oldYear = typeof oldVal == 'string' ? oldVal : (oldVal instanceof Object ? oldVal.getFullYear() : '')
			let newYear = typeof newVal == 'string' ? newVal : (newVal instanceof Object ? newVal.getFullYear() : '') // 是否为初始时间 或 清空
			let list = this.monthList
			// 选中当前年份时，月份列表截止当前月份
			if(nowYear == newYear){
				this.HKMonthList = list.slice(0, nowMonth + 1)
				return
			} else {
				this.HKMonthList = list
			}
			
		}
	},
	methods: {
		// 大陆体检 时间筛选
		handleAction() {
			let data = {
				year: typeof this.tYear == 'string' ? this.tYear : (this.tYear instanceof Object ? this.tYear.getFullYear() : ''),
				month: this.tMonth 
			}
		},
		// 香港体检 时间筛选
		handleHKAction() {
			let data = {
				year: typeof this.HKYear == 'string' ? this.HKYear : (this.HKYear instanceof Object ? this.HKYear.getFullYear() : ''),
				month: this.HKMonth 
			}
		},
	}
};
</script>

<style scoped>
.wrap {
	margin-top: 24px;
}

.tabel-header {
	text-align: center;
	border-left: 2px solid #f1f5fc;
}

.mainland >>> .el-table--striped .el-table__body tr.el-table__row--striped td {
	background: #f1f5fc !important;
}

.mainland >>> .el-table .cell {
	text-align: center;
	font-weight: 500;
	font-size: 16px;
}

.mainland >>> .el-table td {
	color: #40444d;
}

.mainland >>> .el-table--border td,
.el-table--border th,
.el-table__body-wrapper .el-table--border.is-scrolling-left ~ .el-table__fixed {
	border-right: 2px solid #e9eff8;
	height: 54px;
}
</style>
<style lang="scss" scoped>
.update {
	padding: 28px 24px;
	.mainland {
		margin-bottom: 32px;
	}

	.red-text {
		color: #fd1919;
	}

	.mainland-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 66px;
		padding: 0 24px 0 40px;
		border: 2px solid #f1f5fc;
		border-bottom: none;

		.mainland-title {
			font-size: 16px;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #40444d;
		}
	}
	
	.mainland-action {
		display: flex;
		align-items: center;
		
		.receivables {
			font-size: 16px;
			font-family: PingFang-SC-Medium, PingFang-SC;
			font-weight: 500;
			color: #40444d;
		}
		
		.actual-collection {
			font-size: 16px;
			font-family: PingFang-SC-Medium, PingFang-SC;
			font-weight: 500;
			color: #40444d;
			margin-left: 64px;
			margin-right: 56px;
		}
	}
	
	.year-picker {
		width: 120px;
		margin-right: 10px;
	}
	
	.month-select {
		width: 100px;
	}
	
	.mainland-btn {
		width: 80px;
		height: 40px;
		font-size: 14px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #FFFFFF;
		background: #6681FA;
		border: none;
		border-radius: 4px;
		margin-left: 10px;
	}
	
	.el-button:active {
		background-color: #5B73DC;
	}
}
</style>
